"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2 .01 7z"
}), 'SendSharp');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@material-ui+icons@4.11.3_@material-ui+core@4.12.4_@types+react@19.0.10_react-dom@16.14.0_rea_swut4f7lhb7ezcqzt2ohijeqoa/~/@material-ui/icons/SendSharp.js
// module id = 4995
// module chunks = 0